/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tab_AllInputs */

const th_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทั้งหมด`)
};

const en_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const ja_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

const zh_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const es_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo`)
};

const pt_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo`)
};

const id_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const fr_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout`)
};

const tl_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lahat`)
};

const vi_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tất cả`)
};

const ko_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전체`)
};

const de_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

const ru_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Все`)
};

const tr_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tümü`)
};

const it_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutti`)
};

const pl_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wszystkie`)
};

const uk_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Усі`)
};

const hi_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी`)
};

const ar_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكل`)
};

const ms_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua`)
};

const bn_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সব`)
};

const zh_tw2_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const zh_hk2_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部`)
};

const ur_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سب`)
};

const fa_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`همه`)
};

const sw_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yote`)
};

const nl_tab_all = /** @type {(inputs: Tab_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Tab_AllInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const tab_all = /** @type {((inputs?: Tab_AllInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tab_AllInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_tab_all(inputs)
	if (locale === "ja") return ja_tab_all(inputs)
	if (locale === "zh") return zh_tab_all(inputs)
	if (locale === "es") return es_tab_all(inputs)
	if (locale === "pt") return pt_tab_all(inputs)
	if (locale === "id") return id_tab_all(inputs)
	if (locale === "fr") return fr_tab_all(inputs)
	if (locale === "tl") return tl_tab_all(inputs)
	if (locale === "vi") return vi_tab_all(inputs)
	if (locale === "ko") return ko_tab_all(inputs)
	if (locale === "de") return de_tab_all(inputs)
	if (locale === "ru") return ru_tab_all(inputs)
	if (locale === "tr") return tr_tab_all(inputs)
	if (locale === "it") return it_tab_all(inputs)
	if (locale === "pl") return pl_tab_all(inputs)
	if (locale === "uk") return uk_tab_all(inputs)
	if (locale === "hi") return hi_tab_all(inputs)
	if (locale === "ar") return ar_tab_all(inputs)
	if (locale === "ms") return ms_tab_all(inputs)
	if (locale === "bn") return bn_tab_all(inputs)
	if (locale === "zh-TW") return zh_tw2_tab_all(inputs)
	if (locale === "zh-HK") return zh_hk2_tab_all(inputs)
	if (locale === "ur") return ur_tab_all(inputs)
	if (locale === "fa") return fa_tab_all(inputs)
	if (locale === "sw") return sw_tab_all(inputs)
	if (locale === "nl") return nl_tab_all(inputs)
	return en_tab_all(inputs)
});